import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getFetchItems = createSelector(
    getModel,
    (model) => model.fetchItems,
);

export const getIsFetchingCurrencies = createSelector(
    getFetchItems,
    (fetchItems) => fetchItems.isFetching,
);

export const getDataFetchItems = createSelector(
    getFetchItems,
    (fetchItems) => fetchItems.data || [],
);

export const getDataFetchCurrencies = createSelector(
    getDataFetchItems,
    (currencies) =>
        currencies
            .filter(
                (item) => item.is_enabled && !item.is_deleted && item.currency,
            )
            .map((item) => ({
                ...item.currency,
                dollar_price: item?.dollar_price,
                exchange_rate_id: item.id,
                exchange_type: item?.exchange_type,
                inverse_dollar_price: item?.inverse_dollar_price,
                source: item?.source,
            })) || [],
);

export const getDataFetchCurrenciesDictionary = createSelector(
    getDataFetchCurrencies,
    (data) =>
        data.reduce((acc, item) => {
            acc[item.id] = item;
            return acc;
        }, {}),
);

export const getDataFetchCurrenciesForSelect = createSelector(
    getDataFetchCurrencies,
    (data) => [
        {
            label: '',
            options: data.map((item) => ({
                label: item.name,
                value: item?.id,
            })),
        },
    ],
);

export const getErrorsFetchItems = createSelector(
    getFetchItems,
    (fetchItems) => fetchItems.errors,
);
